module.exports = __webpack_public_path__ + "img/products_big_can_lemon.d90b6dd6.png";